import { render, staticRenderFns } from "./TaskFormView.vue?vue&type=template&id=5723e0ce&"
import script from "./TaskFormView.vue?vue&type=script&lang=js&"
export * from "./TaskFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports